/* Variant picker for any [data-product-form]. Updates id, price, button, URL, media, unavailable pills. */
(() => {
  if (window.__nsVariants) return;
  window.__nsVariants = true;

  const fmt = (cents) => {
    const tpl = window.NSMoney || '${{amount}}';
    const n = (Number(cents) / 100);
    const withDelims = (num, dec, th, ds) => { const [a, b] = num.toFixed(dec).split('.'); return a.replace(/\B(?=(\d{3})+(?!\d))/g, th) + (b ? ds + b : ''); };
    return tpl.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => ({ amount: withDelims(n, 2, ',', '.'), amount_no_decimals: withDelims(n, 0, ',', '.'), amount_with_comma_separator: withDelims(n, 2, '.', ','), amount_no_decimals_with_comma_separator: withDelims(n, 0, '.', ',') }[k] || withDelims(n, 2, ',', '.')));
  };
  window.NS = window.NS || {};
  NS.money = fmt;

  function sync(root) {
    const variants = JSON.parse(root.querySelector('[data-variants]').textContent);
    const sets = [...root.querySelectorAll('[data-option-index]')];
    const selected = sets.map((fs) => fs.querySelector('input:checked')?.value);
    const variant = variants.find((v) => v.options.every((o, i) => o === selected[i]));
    const scope = root.closest('[data-product-scope]') || root.parentElement;

    sets.forEach((fs, i) => {
      fs.querySelector('[data-selected-value]').textContent = selected[i] || '';
      fs.querySelectorAll('input').forEach((input) => {
        const probe = selected.slice(); probe[i] = input.value;
        const ok = variants.some((v) => v.available && v.options.every((o, j) => o === probe[j]));
        input.nextElementSibling.classList.toggle('is-unavailable', !ok);
      });
    });

    const idInput = root.querySelector('[data-variant-id]');
    const btn = root.querySelector('[data-add-button]');
    const label = root.querySelector('[data-add-label]');
    if (!variant) {
      if (btn) { idInput.disabled = true; btn.disabled = true; label.textContent = window.NSStrings?.unavailable || 'Unavailable'; }
      return;
    }
    // No add button = price-on-request piece (see product-form.liquid).
    if (btn) {
      idInput.value = variant.id; idInput.disabled = !variant.available;
      btn.disabled = !variant.available;
      label.textContent = variant.available ? btn.dataset.labelAdd : (window.NSStrings?.soldOut || 'Sold out');
    }

    scope.querySelectorAll('[data-price]').forEach((p) => {
      const sale = variant.compare_at_price && variant.compare_at_price > variant.price;
      p.hidden = !variant.price;
      p.innerHTML = sale ? `<span class="price__sale">${fmt(variant.price)}</span><s class="price__compare">${fmt(variant.compare_at_price)}</s>` : `<span>${fmt(variant.price)}</span>`;
    });
    scope.querySelectorAll('[data-sku]').forEach((el) => { el.textContent = variant.sku || ''; el.closest('[data-sku-wrap]')?.toggleAttribute('hidden', !variant.sku); });

    if (root.hasAttribute('data-update-url')) {
      const url = new URL(location.href); url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url);
    }
    if (variant.featured_media) scope.dispatchEvent(new CustomEvent('ns:variant-media', { bubbles: true, detail: variant.featured_media.id }));
    root.dispatchEvent(new CustomEvent('ns:variant', { bubbles: true, detail: variant }));
  }

  document.addEventListener('change', (e) => {
    const root = e.target.closest('[data-product-form]');
    if (root && e.target.closest('[data-option-index]')) sync(root);
  });
  const initAll = (scope = document) => scope.querySelectorAll('[data-product-form]').forEach((r) => { if (!r.dataset.synced) { r.dataset.synced = 1; if (r.querySelector('[data-option-index]')) sync(r); } });
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', () => initAll()) : initAll();
  document.addEventListener('ns:dom-updated', (e) => initAll(e.detail instanceof Element ? e.detail : document));
})();
